// services/Recruit/services/feedback.js
import axios from 'axios';
import { constant } from 'common/constant';

class FeedbackService {
  async downloadFeedbackPDF(id) {
    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      
      console.log('=== PDF Download Request Starting ===');
      console.log('- URL:', `${constant.baseUrl}api/recruitment/feedback/${id}/download`);
      console.log('- Token present:', !!token);

      const response = await axios.get(
        `${constant.baseUrl}api/recruitment/feedback/${id}/download`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/pdf",
          },
          responseType: "blob", // Return as blob directly
        }
      );

      
      // Check if blob contains JSON error instead of PDF
      if (response.data.type === 'application/json') {
        console.error('ERROR: Received JSON instead of PDF!');
        const text = await response.data.text();
        console.error('JSON content:', text);
        throw new Error('Server returned JSON instead of PDF: ' + text);
      }

      return response.data; // Returns Blob
    } catch (error) {
      console.error('=== PDF Download Error ===');
      console.error('- Error:', error);
      console.error('- Response status:', error.response?.status);
      console.error('- Response data:', error.response?.data);
      throw error;
    }
  }
}

export default new FeedbackService();